'use client';

import { Button } from '@/components/button';
import classes from '@/components/marketingOptInInfoIconModal/MarketingOptInInfoIconModal.module.scss';
import { markPendingLogoutPopup } from '@/helper/globalPopupEvents';
import { buildSelfServicePath } from '@/helper/selfServicePath';
import { useSettings } from '@/providers/SettingsProvider';
import { useUserStore } from '@/providers/UserStoreProvider';
import LogoutIcon from '@/public/icons/material/logout.svg';
import { useTranslation } from 'react-i18next';

import InfoIconModal from '../infoIcon/InfoIconModal';
import { RichText } from '../richText/RichText';

export const MarketingOptInInfoIconModal: React.FC = (props) => {
  const settings = useSettings();

  const { t } = useTranslation();
  const logout = useUserStore((state) => state.logout);
  return (
    <InfoIconModal>
      <>
        <RichText text={settings?.cdc_marketing_optin_email_field_info_text} />
        <div className={classes.buttonWrapper}>
          <Button
            data-testid="marketing-opt-in-logout-button"
            variant="ctaFull"
            fullWidth={false}
            endIcon={<LogoutIcon />}
            onClick={() => {
              markPendingLogoutPopup();
              logout('marketing_optin_info_icon_modal_click');
              window.open(buildSelfServicePath('/logout'), '_self');
            }}
          >
            {t('Hier ausloggen')}
          </Button>
        </div>
      </>
    </InfoIconModal>
  );
};
